import Project1 from './assets/yogesh-singh-portfolio-desko-home-ecommerce.jpg';
import Project2 from './assets/yogesh-singh-portfolio-scholarshipkart-education.jpg';
import Project4 from './assets/yogesh-singh-portfolio-admin-dashboard-react-mui.png';
import Project6 from './assets/yogesh-singh-portfolio-sainik-car-rentals-react.png';
import MillImage from './assets/yogesh-singh-portfolio-business-websites-nextjs.png';
import ResearchImage from './assets/yogesh-singh-portfolio-research-journal-react.png';
import HMSImage from './assets/yogesh-singh-portfolio-hospital-management-react.png';
import BillingImage from './assets/yogesh-singh-portfolio-gst-billing-nextjs.png';

import Testimonial1 from './assets/yogesh-singh-testimonial-dr-anoop.png';
import Testimonial2Img from './assets/yogesh-singh-testimonial-devendra-singh.png';

export const links = [
  {
    name: 'Home',
    path: 'home',
    navType: 'scroll',
  },
  {
    name: 'About',
    path: '/yogesh-singh',
    navType: 'route',
  },
  {
    name: 'Skills',
    path: 'skills',
    navType: 'scroll',
  },
  {
    name: 'Projects',
    path: 'work',
    navType: 'scroll',
  },
  {
    name: 'Experience',
    path: 'resume',
    navType: 'scroll',
  },
  {
    name: 'Testimonials',
    path: 'testimonial',
    navType: 'scroll',
  },
  {
    name: 'Contact',
    path: 'contact',
    navType: 'scroll',
  },
];

export const services = [
  {
    id: 1,
    name: 'React & Next.js',
    title: 'Modern React Development',
    description:
      'Expert in building production-ready applications with React 18/19 and Next.js 14+. Specialized in Server Components, App Router, and TypeScript. Delivered 10+ enterprise applications serving 100K+ users with 99.9% uptime.',
  },
  {
    id: 2,
    name: 'UI/UX Engineering',
    title: 'Responsive UI & Design Systems',
    description:
      'Crafting pixel-perfect, accessible interfaces with Tailwind CSS, Material UI, and Shadcn. Built reusable component libraries reducing development time by 40%. Mobile-first approach ensuring seamless experience across all devices.',
  },
  {
    id: 3,
    name: 'Web Performance',
    title: 'Performance & SEO Optimization',
    description:
      'Achieved 90+ Lighthouse scores through code splitting, lazy loading, and Core Web Vitals optimization. Improved page load times by 50% and conversion rates by 30%. Expert in SSR, SSG, and ISR strategies.',
  },
  {
    id: 4,
    name: 'State & API',
    title: 'State Management & API Integration',
    description:
      'Architecting scalable data layers with Redux Toolkit, Zustand, and React Query. Seamless REST/GraphQL API integration with Axios and SWR. Built real-time features using WebSockets and WebRTC for live collaboration.',
  },
];

export const skills = [
  {
    id: 1,
    name: 'JavaScript',
    percentage: 95,
    description:
      'Modern ES6+ JavaScript for building dynamic and interactive web applications',
  },
  {
    id: 2,
    name: 'TypeScript',
    percentage: 90,
    description:
      'Type-safe development for scalable and maintainable enterprise applications',
  },
  {
    id: 3,
    name: 'React.js',
    percentage: 95,
    description:
      'Expert in React 18/19, hooks, context, and component-driven architecture',
  },
  {
    id: 4,
    name: 'Next.js',
    percentage: 90,
    description:
      'Server-side rendering, App Router, and full-stack React framework expertise',
  },
  {
    id: 5,
    name: 'HTML5',
    percentage: 95,
    description:
      'Semantic markup and accessibility-first web development standards',
  },
  {
    id: 6,
    name: 'CSS3',
    percentage: 95,
    description:
      'Modern CSS, Flexbox, Grid, animations, and responsive design patterns',
  },
  {
    id: 7,
    name: 'Tailwind CSS',
    percentage: 95,
    description:
      'Utility-first CSS framework for rapid UI development and design systems',
  },
  {
    id: 8,
    name: 'Material UI',
    percentage: 85,
    description:
      'React component library for building professional enterprise interfaces',
  },
  {
    id: 9,
    name: 'Redux',
    percentage: 90,
    description:
      'Global state management with Redux Toolkit for complex applications',
  },
  {
    id: 10,
    name: 'Zustand',
    percentage: 85,
    description:
      'Lightweight state management solution for modern React applications',
  },
  {
    id: 11,
    name: 'Framer Motion',
    percentage: 80,
    description:
      'Production-ready animations and transitions for React applications',
  },
  {
    id: 12,
    name: 'React Hook Form',
    percentage: 90,
    description:
      'Performant form handling and validation with minimal re-renders',
  }
];


export const projects = [
  {
    id: 1,
    img: Project1,
    linkUrl: 'https://deskohome.com/',
    category: 'Development',
    title: 'DeskoHome – Premium Furniture E-Commerce',
    description:
      'Furniture e-commerce platform with advanced filtering and optimized checkout UX.',
    techStack: 'React.js • Node.js • MongoDB',
    role: 'Frontend Developer',
    impact: '50% higher conversion rate • Mobile-first responsive design',
  },
  {
    id: 2,
    img: BillingImage,
    category: 'Development',
    linkUrl: 'https://billing.sainikcarrentals.com/',
    title: 'Invoice Generator – GST Billing System',
    description: 'GST compliant invoice generator with automatic tax calculation and PDF generation.',
    techStack: 'Next.js 16 • React 19 • TypeScript',
    role: 'Full Stack Developer',
    impact: 'IGST/CGST/SGST automation • Custom PDF export',
  },
  {
    id: 3,
    img: Project2,
    category: 'Development',
    linkUrl: 'https://scholarshipkart.com/',
    title: 'ScholarshipKart – Education Platform',
    description:
      'Scholarship search platform with filtering and notification system.',
    techStack: 'React.js • Bootstrap • PHP',
    role: 'Frontend Developer',
    impact: '10,000+ monthly active users • Advanced search filtering',
  },
  {
    id: 4,
    img: Project4,
    category: 'Development',
    linkUrl: 'https://mui-test-8mob-git-main-yttmlvgmailcoms-projects.vercel.app/dashboard',
    title: 'Professional Admin Dashboard',
    description:
      'Scalable admin dashboard with analytics and reusable component architecture.',
    techStack: 'React.js • Material UI • Chart.js',
    role: 'Frontend Developer',
    impact: '40% productivity improvement • Real-time analytics',
  },
  {
    id: 5,
    img: Project6,
    category: 'Development',
    linkUrl: 'https://sainikcarrentals.com/',
    title: 'Sainik Car Rentals – Travel Booking Platform',
    description:
      'Car rental booking platform with WhatsApp automation integration.',
    techStack: 'React.js • WhatsApp API • Email.js',
    role: 'Frontend Developer',
    impact: '200+ monthly bookings • Automated booking system',
  },
  {
    id: 6,
    img: ResearchImage,
    category: 'Development',
    linkUrl: 'http://imjsmhonline.com/',
    title: 'International Research Journal Platform',
    description:
      'Research publication platform with manuscript submission workflow.',
    techStack: 'React.js • Node.js • MongoDB',
    role: 'Frontend Developer',
    impact: 'Advanced search system • Workflow automation',
  },
  {
    id: 7,
    img: HMSImage,
    category: 'Development',
    linkUrl: 'https://aaldavet360.com/',
    title: 'Hospital Management System (HMS)',
    description:
      'Scalable HMS dashboard with role-based access control and modular architecture.',
    techStack: 'React.js • Redux • Material UI',
    role: 'Frontend Developer',
    impact: '350+ hospitals • Live in Japan',
  },
  {
    id: 8,
    img: MillImage,
    category: 'Development',
    linkUrl: 'https://www.siddhivinayakmillcare.com/',
    title: 'Client Projects – School & Business Websites',
    description:
      'SEO optimized responsive websites for educational institutions and businesses.',
    techStack: 'React.js • Next.js • Tailwind CSS',
    role: 'Frontend Developer',
    impact: 'Mobile-first design • 90+ Lighthouse scores',
  },
];

export const cv = [
  {
    id: 1,
    title: 'Rajasthan Technical University, Kota',
    subtitle: 'B.Tech – Textile Technology | RTU Kota | 2019',
    date: '2015 - 2019',
    description:
      'Graduated with honors in Textile Engineering, building strong analytical and problem-solving skills.',
    category: 'education',
  },

  {
    id: 2,
    title: 'BIC College, Gorakhpur',
    subtitle: 'Intermediate – Science (PCM) | BIC College | 2015',
    date: '2013 - 2015',
    description:
      'Achieved second rank with 88% in Science stream, demonstrating strong foundation in mathematics and logical reasoning.',
    category: 'education',
  },

  {
    id: 3,
    title: 'SDE-1',
    subtitle: 'Adda247 - India\'s Leading EdTech Platform | Gurgaon, India',
    date: 'March 2025 - Present',
    description:
      'Building scalable EdTech solutions for Career247 and real-time live classroom platforms serving thousands of concurrent users.',
    techStack: 'React 18 • Next.js • Redux Toolkit • Zustand • Tailwind CSS • AWS IVS • WebRTC • Socket.IO',
    contributions: [
      'Developed Career247 platform with Next.js and Zustand, optimizing SEO and Core Web Vitals',
      'Architected low-latency real-time live classroom supporting thousands of concurrent students',
      'Implemented WebRTC multi-role system with screen sharing and interactive whiteboard',
      'Built real-time engagement features: chat, polls, hand-raise, and doubt-resolution'
    ],
    impact: 'Thousands of concurrent users • 90+ Lighthouse scores • Real-time collaboration',
    category: 'experience',
  },
  
  {
    id: 4,
    title: 'Software Engineer',
    subtitle: 'A\'alda Vet India Pvt. Ltd (Japan/India) | Gurgaon, India',
    date: 'April 2023 - Feb 2025',
    description:
      'Developed VET360HMS clinic workflow system and DCC Animal Hospital booking platform for veterinary care.',
    techStack: 'React.js • Next.js • Redux • Vite • Material UI • JIRA • Sentry',
    contributions: [
      'Designed VET360HMS clinic workflow components with React and Vite',
      'Built custom Rich Text Editor for veterinary documentation workflows',
      'Led DCC Animal Hospital Online Booking System development with Next.js',
      'Integrated Slack, JIRA, and Sentry for project tracking'
    ],
    impact: '350+ hospitals • Live in Japan • 30% faster milestone tracking',
    category: 'experience',
  },
  
  {
    id: 5,
    title: 'Software Developer',
    subtitle: 'Aarya Printers | Delhi/Remote',
    date: 'April 2022 - March 2023',
    description:
      'Built Canvas-like web design editor for print templates with drag-and-drop functionality and real-time preview.',
    techStack: 'React.js • HTML5 Canvas • Fabric.js • AWS S3 • CloudFront • Route53',
    contributions: [
      'Developed in-house web design editor using HTML5 Canvas and Fabric.js',
      'Implemented drag-and-drop editing, layer management, and real-time preview',
      'Deployed frontend assets using AWS S3, CloudFront, and Route53',
      'Optimized project tracking with Slack, JIRA, and Sentry integration'
    ],
    impact: 'Custom print template editor • 30% faster project delivery',
    category: 'experience',
  },

  {
    id: 6,
    title: 'Freelance Frontend Developer',
    subtitle: 'Freelance',
    date: '2022 - Present',
    description:
      'Building SEO-optimized responsive websites for schools, businesses, and local companies.',
    techStack: 'React.js • Next.js • Material UI • Tailwind CSS',
    contributions: [
      'Delivered 10+ client projects including school and business websites',
      'Implemented SEO best practices and mobile-first responsive design',
      'Built custom components and reusable UI libraries'
    ],
    impact: '90+ Lighthouse scores • Mobile-first design • SEO optimized',
    category: 'experience',
  },
];

export const testimonials = [
  {
    id: 1,
    img: Testimonial1,
    name: 'Dr. Anoop',
    author: 'Founder — Aude Sapere',
    description:
      'The website exceeded all expectations with user-friendly design and responsive performance. A game-changer for my business!',
    rating: 5,
  },
  {
    id: 2,
    img: Testimonial2Img,
    name: 'Devendra Singh',
    author: 'Founder — Sainik Tour & Travels',
    description:
      'Yogesh delivered an excellent web platform with clean UI and fast performance. Highly recommended for React development.',
    rating: 5,
  },
];

export const achievements = [
  {
    id: 1,
    title: 'Built 15+ production web applications',
    description: 'Delivered scalable solutions across e-commerce, healthcare, and EdTech domains',
  },
  {
    id: 2,
    title: '4+ years of frontend development experience',
    description: 'Specialized in React, Next.js, and modern JavaScript ecosystem',
  },
  {
    id: 3,
    title: 'Developed scalable dashboards and healthcare platforms',
    description: 'Built VET360HMS serving 350+ hospitals live in Japan',
  },
  {
    id: 4,
    title: 'Improved e-commerce conversion rate by 50%',
    description: 'Optimized UX and checkout flow for premium furniture platform',
  },
  {
    id: 5,
    title: 'Built systems used by 10,000+ users',
    description: 'Real-time live classroom and scholarship platforms with high traffic',
  },
  {
    id: 6,
    title: 'Specialized in React, Next.js and modern frontend architecture',
    description: 'Expert in TypeScript, Redux, Zustand, and performance optimization',
  },
];
